"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoMark = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const logo_mark_style_1 = __importDefault(require("./logo.mark.style"));
class LogoMark extends react_1.Component {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('lm_');
        this.render = () => {
            const { classes, axis, size, fill } = this.props;
            const style = {
                width: axis === 'x' ? size || '100%' : 'auto',
                height: axis === 'y' ? size || '100%' : 'auto'
            };
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 84", "aria-hidden": "true", className: classes.root, style: style }, { children: [jsx_runtime_1.jsxs("clipPath", Object.assign({ id: this.id }, { children: [jsx_runtime_1.jsx("rect", { x: "0", y: "0", width: "25.7", height: "46.3", rx: "3.9", ry: "3.9" }, void 0),
                            jsx_runtime_1.jsx("rect", { x: "37.2", y: "0", width: "25.7", height: "84", rx: "3.9", ry: "3.9" }, void 0),
                            jsx_runtime_1.jsx("rect", { x: "74.3", y: "0", width: "25.7", height: "65.3", rx: "3.9", ry: "3.9" }, void 0)] }), void 0),
                    fill && (jsx_runtime_1.jsx("g", Object.assign({ clipPath: `url(#${this.id})`, className: classes.fill }, { children: jsx_runtime_1.jsx("rect", { x: "0", y: "0", width: "100", height: "84" }, void 0) }), void 0)),
                    !fill && (jsx_runtime_1.jsxs("g", Object.assign({ clipPath: `url(#${this.id})`, className: classes.bands }, { children: [jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "245.65" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "228.5" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "211.3" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "194.1" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "176.95" }, void 0),
                            jsx_runtime_1.jsx("circle", { cx: "-46.1", cy: "198.8", r: "159.75" }, void 0)] }), void 0))] }), void 0));
        };
    }
}
exports.LogoMark = LogoMark;
LogoMark.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    axis: prop_types_1.default.oneOf(['x', 'y']),
    size: prop_types_1.default.number,
    fill: prop_types_1.default.bool
};
LogoMark.defaultProps = {
    axis: 'x',
    size: null,
    fill: false
};
exports.default = react_jss_1.default(logo_mark_style_1.default)(LogoMark);
//# sourceMappingURL=logo.mark.js.map